import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt="" style={{maxWidth:'100%'}}
                                                 src={require('@images/How to  improveme processes.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">isn't it interesting?</span>
                                            </div>
                                            <div className="border_subtitle">Once upon a time...</div>
                                            <p>Have you ever wondered why stories can be spellbinding or so
                                                powerful? We all use stories in our problem solving – we
                                                just might not know it. We use ‘scripts’ to help us deal
                                                with events such as a restaurant script which tells us how
                                                to behave, and what to expect, in a restaurant from our
                                                experiences. Similarly, when we read or hear stories, we are
                                                assisted in our interpretation by ‘story schemas’. Schemas
                                                are bodies of knowledge that provide frameworks for
                                                understanding, for encoding new knowledge and for retrieving
                                                information. Our ability to spot and identify problems or
                                                improvements is thought to depend on how developed our
                                                schemas and scripts are.</p>

                                            <div className="lightgreencontentbg">
                                                <div className="border_subtitle">Spot the clue</div>
                                                <p>In 1980, Gick and Holyoak<a className="superscripttext"
                                                                               href="further_info.php?course=300"><sup>1</sup></a> carried
                                                    out a study into solution development where participants
                                                    were presented with a problem to solve. The researchers
                                                    wanted to see under what conditions people would be able
                                                    to spot and spontaneously apply already existing and
                                                    effective solutions to the new problem they were
                                                    presented with.</p>
                                                <p>They split people into three groups. Group 1 were
                                                    instructed to read a story about a similar problem (in a
                                                    different context) and the way in which it was solved
                                                    and were given a hint that the solution to their problem
                                                    might have been in the story. Group 2 were asked to read
                                                    the story as well but were not given the hint. Group 3
                                                    did not read the story at all.</p>
                                                <div className="uiheading">
                                                    <p>The results showed that most people who had been told
                                                        the story and given the hint had no problem applying
                                                        it to their own problem. Without this knowledge,
                                                        however, very few participants were spontaneously
                                                        able to spot the analogy and resolve their problem
                                                        in an effective way. Most took the longer route of
                                                        trying to think of several new, but incorrect,
                                                        solutions.</p>
                                                </div>
                                            </div>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}